// extracted by mini-css-extract-plugin
export default {"Form":"custom-specification_Form__ZQxKW"};